export default __webpack_public_path__ + "static/media/4.13426daf.jpg";